import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NbDialogService } from '@nebular/theme';
import { RoleEditModalComponent } from './edit/role-edit-modal.component';
import { ConfirmModalComponent } from '../modals/confirm-modal.component';

import { MissionService, GameService, TemplateService, RoleService, LanguageService } from '../../_services/index';
import { Role } from '../../classes';

import { RoleChangesModalComponent } from './changes/role-changes-modal.component';

import { take } from 'rxjs/operators';

@Component({
    selector: 'app-edit-roles-param',
    templateUrl: './edit-roles.component.html',
    styleUrls: ['./edit-roles.component.scss'],
    standalone: false
})

export class EditRolesComponent {

  roles = [];
  roleSubscriber;
  
  gameId;
  game;
  templateId;
  template;

  games;

  url;

  constructor(private route: ActivatedRoute,
    public roleService: RoleService,
    public gameService: GameService,
    public missionService: MissionService,
    public templateService: TemplateService,
    private dialogService: NbDialogService,
    public languageService: LanguageService) {
      this.route
      .params
      .subscribe(params => {
        // Récupération des valeurs de l'URL
        console.log('params:'+JSON.stringify(params));
        this.gameId = params['id'];
        this.templateId = params['templateId'];
        console.log('Load data - gameId:'+this.gameId+', templateId:'+this.templateId);
        
        if(this.roleSubscriber){
          this.roleSubscriber.unsubscribe();
        }
        if(this.gameId){
          this.gameService.getGame(this.gameId)
          .subscribe(game => {
            if(game){
              this.game = game;
            }
          });
          this.roleSubscriber = this.roleService.listRoles(`games/${this.gameId}/roles`)
          .subscribe(roles => {;
            if(roles){
              this.roles = this.sort(roles);
              if(!this.isOrdered(this.roles)) {
                this.setOrder(this.roles);
                this.saveOrder(this.roles);
              }
            }
          });
        }
        else if(this.templateId){
          this.templateService.getTemplate(this.templateId)
          .subscribe(template => {
            if(template){
              this.template = template;
            }
          });
          this.roleSubscriber = this.roleService.listRoles(`game_templates/${this.templateId}/roles`)
          .subscribe(roles => {
            if(roles){
              this.roles = this.sort(roles);
              if(!this.isOrdered(this.roles)) {
                this.setOrder(this.roles);
                this.saveOrder(this.roles);
              }
            }
          });
        }
      });
  }

  isOrdered(objects) {
    let exist = true
    for (let i = 0; i < objects.length; i++) {
      if (!objects[i]?.orderNum) {
        exist = false;
      }
    }
    return exist;
  }

  setOrder(roles){
    for (let j = 0; j < roles.length; j++) {
      roles[j].orderNum = j+1;
    }
  }

  sort(roles){
    return roles.sort((x, y) => x.orderNum - y.orderNum);
  }

  changePosition(old_index, new_index){
    this.roles[old_index].orderNum = new_index
    this.roles[new_index].orderNum = old_index
    
    this.saveOrderObject(this.roles[old_index])
    this.saveOrderObject(this.roles[new_index])
    this.roles = this.sort(this.roles);
  }

  saveOrder(objects){
    for (const object of objects) {
      this.saveOrderObject(object)
    }
  }

  async saveOrderObject(object){
    await this.roleService.setRole(object).then(value => {
    }, err => {
      console.log('err :', err)
    });
  }
  
  
  applyChanges(){
    this.gameService.listTemplateGames(this.template.id)
    .pipe(take(1))
    .subscribe(async games => {
      this.games = games;
      this.dialogService.open(RoleChangesModalComponent, { 
        context: {
          data : {
            currentLang:this.languageService.currentLang,
            games: this.games,
            templateId:this.templateId,
            templateRoles:this.roles
          }
        },
      })
      .onClose.subscribe(async res => {
        console.log('Dialog returns:'+res);
        if(res){
        }
      });
    })
  }

  ngOnInit() {
  }

  editRole(role){
    if(this.gameId){
      if(!role){
        role = new Role(`games/${this.game.id}/roles`);
        role.gameId = this.gameId;
        role.orderNum = this.roles.length+1;
      }
      this.dialogService.open(RoleEditModalComponent, { 
        context: {
          model: role,
          game: this.game,
          languages: this.game.workingLanguages
        }, closeOnBackdropClick: false
      })
      .onClose.subscribe(res => {
        console.log('Dialog returns:'+res);
      });
    } else {
      if(!role){
        role = new Role(`game_templates/${this.templateId}/roles`);
        role.templateId = this.templateId;
      }
      this.dialogService.open(RoleEditModalComponent, { 
        context: {
          model: role,
          game: this.game,
          languages: this.template.workingLanguages
        }, closeOnBackdropClick: false
      })
      .onClose.subscribe(res => {
        console.log('Dialog returns:'+res);
      });
    }
  }

  deleteRole(role){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Do you want to delete role '`+role.labels[this.languageService.currentLang]+`'?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        console.log('Delete mission');
        await this.roleService.deleteRole(role);
        this.setOrder(this.roles);
        this.saveOrder(this.roles);
      }
    });
  }
}